var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useContext } from "react";
import "../scss/OffCanvasMenu.scss";
import Backdrop from "../../backdrop";
import Button from "../../button";
import OffCanvasMenuContext from "./OffCanvasMenuContext";
var OffCanvasMenu = function (_a) {
    var label = _a.label, children = _a.children, cssClasses = _a.cssClasses;
    var modalMenu = useRef(null);
    var modalMenuCloseButton = useRef(null);
    var _b = useState(false), isActive = _b[0], setIsActive = _b[1];
    var _c = useState(false), animateFadeOut = _c[0], setAnimateFadeOut = _c[1];
    var closeMenuAction = function () {
        setAnimateFadeOut(true);
        setTimeout(function () {
            setIsActive(false);
            setAnimateFadeOut(false);
        }, 600);
    };
    var openMenuAction = function () {
        var _a, _b;
        setIsActive(true);
        (_a = modalMenuCloseButton.current) === null || _a === void 0 ? void 0 : _a.focus();
        (_b = modalMenu.current) === null || _b === void 0 ? void 0 : _b.addEventListener("focusout", function (ev) {
            var _a, _b;
            if (!((_a = modalMenu.current) === null || _a === void 0 ? void 0 : _a.contains(ev.relatedTarget))) {
                (_b = modalMenuCloseButton.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        });
    };
    var context = useContext(OffCanvasMenuContext);
    if (context && typeof context.openCloseHandler === 'function') {
        context.openCloseHandler(isActive);
    }
    return (_jsxs("div", __assign({ className: cssClasses }, { children: [_jsx(Button, __assign({ type: "link", callback: function () { return openMenuAction(); }, "aria-haspopup": "true", "aria-expanded": isActive, "aria-controls": "off-canvas-modal-menu" }, { children: label })), _jsxs("div", __assign({ ref: modalMenu, id: "off-canvas-modal-menu", onKeyDown: function (e) { if (e.key === "Escape") {
                    closeMenuAction();
                } }, role: "modal", "aria-modal": "true", "aria-label": "You are in a modal", className: "OffCanvasMenu ".concat(animateFadeOut ? "remove" : "", " ").concat(isActive ? "" : "is-hidden") }, { children: [_jsxs("div", __assign({ ref: modalMenuCloseButton, onClick: function () { return closeMenuAction(); }, onKeyDown: function (e) { if (e.key === "Enter") {
                            closeMenuAction();
                        } }, className: "OffCanvasMenu__close-button", role: "button", "aria-label": "Close modal", tabIndex: 0 }, { children: ["Close", _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", "aria-hidden": "true" }, { children: _jsx("path", { d: "M15.232.128c.165.165.165.432 0 .597L8.286 7.68l6.946 6.955a.41.41 0 0 1 0 .597.41.41 0 0 1-.299.128c-.107-.001-.22-.045-.3-.128L7.68 8.277.725 15.232a.41.41 0 0 1-.299.128.42.42 0 0 1-.298-.128.41.41 0 0 1 0-.597L7.074 7.68.128.725C-.037.56-.037.293.128.128s.432-.165.597 0L7.68 7.083 14.635.128c.165-.165.432-.165.597 0z", fill: "#161616", fillRule: "nonzero" }) }))] })), _jsx("div", __assign({ className: "OffCanvasMenu__body" }, { children: _jsx("ul", { children: children.map(function (e, i) { return (_jsx("li", { children: e }, i)); }) }) }))] })), isActive && (_jsx(Backdrop, { cssClasses: animateFadeOut ? "remove" : "", callback: closeMenuAction }))] })));
};
export default OffCanvasMenu;
